import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LANG_FALLBACK, LANG } from '@/shared/config';
import { localize } from 'vee-validate';
import axios from 'axios';
import elLocale from './locales/el.json';

Vue.use(VueI18n);

export const supportedlanguages = ['en', 'el'];
const defaultLang = LANG_FALLBACK || 'el';
const loadedLanguages = [defaultLang];

export function isValidLanguage(lang) {
  return Object.keys(supportedlanguages).includes(lang);
}

export function getStartingLocale() {
  // if language at local storage
  const chooseLanguage = window.localStorage.getItem('language');
  if (chooseLanguage) {
    return chooseLanguage;
  }
  const language = (navigator.language || navigator.browserLanguage).toLowerCase();
  if (language && isValidLanguage(language)) {
    return language;
  }
  return defaultLang;
}

function loadLocaleMessages() {
  const locales = elLocale;
  // console.log(locales);
  const messages = {
    el: locales
  };
  return messages;
}

// function loadLocaleMessages() {
//   const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
//   const messages = {};
//   locales.keys().forEach((key) => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i);
//     if (matched && matched.length > 1) {
//       const locale = matched[1];
//       messages[locale] = locales(key);
//     }
//   });
//   return messages;
// }

async function setValidatorLanguage(lang) {
  let defaultMessages = {};
  // Load default validator messages
  if (lang === 'el') {
    defaultMessages = await import('vee-validate/dist/locale/el.json');
  } else {
    defaultMessages = await import('vee-validate/dist/locale/en.json');
  }
  const customMessages = await import(/* webpackChunkName: "i18-[request]" */ `./i18n_${lang}.json`);

  defaultMessages.default.messages = { ...defaultMessages.messages, ...customMessages.messages };
  localize(lang, defaultMessages);
}

const i18n = new VueI18n({
  locale: LANG || 'el',
  fallbackLocale: LANG_FALLBACK || 'el',
  messages: loadLocaleMessages()
});

export function setI18nLanguage(lang) {
  i18n.locale = lang;
  setValidatorLanguage(lang);
  document.querySelector('html').setAttribute('lang', lang);
  axios.defaults.headers.common['Accept-Language'] = lang;
  window.localStorage.setItem('language', lang);
  return lang;
}

export async function loadLanguageAsync(lang) {
  // Make sure it's a valid language
  let language = lang;
  if (!supportedlanguages.includes(language)) {
    language = defaultLang;
  }
  // If the language was already loaded
  if (loadedLanguages.includes(language)) {
    return setI18nLanguage(language);
  }
  // If the language hasn't been loaded yet
  const messages = await import(/* webpackChunkName: "lang-[request]" */ `./locales/${language}.json`);
  i18n.setLocaleMessage(language, messages);
  loadedLanguages.push(language);
  return setI18nLanguage(language);
}

export default i18n;

loadLanguageAsync(getStartingLocale());
